import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";
import GlobalShippingIcon from "@/images/global_shipping_background_white.svg";

const ProductSizeItem = ({ size, selectedSize, onSizeSelection }) => {
  const { t } = useTranslation("productDetails");
  const outOfStockSizeRef = useRef(null);
  const outOfStock = size?.sizeStock <= 0;

  if (!size.size) return null;

  const isSizeChecked = selectedSize.size?.sizeId === size?.sizeId;

  return (
    <>
      <li
        onClick={() => {
          onSizeSelection(size);
        }}
        className={cn("size_item", "d-inline-block", {
          size_box_color: isSizeChecked,
          "size_not_available not_clickable": outOfStock
        })}
        ref={outOfStockSizeRef}
      >
        {size?.isGlobalShipping && (
          <img className="global_shipping_icon" src={GlobalShippingIcon} />
        )}
        {size.size}
        {size.sizeStock <= 5 && size.sizeStock > 0 && (
          <p className="size_quantity">
            {t("countLeft", { count: size.sizeStock })}
          </p>
        )}
      </li>
    </>
  );
};

export default ProductSizeItem;
